<template>
  <v-row>
    <v-col cols="6">
      <v-text-field
                    label="Dê um nome para este cartão"
                    v-model="value.name"
                    disabled
                    :rules="rules.required"></v-text-field>
    </v-col>
    <v-col cols="6">
      <v-text-field
                    label="Nome impresso no cartão"
                    v-model="value.cardHolder"
                    :rules="rules.required"></v-text-field>
    </v-col>
    <v-col cols="3">
      <v-text-field
                    label="Número do cartão"
                    v-model="value.cardNumber"
                    :rules="[rules.cardNumber, rules.cardBrand].flat()"
                    v-mask="'################'"></v-text-field>
    </v-col>
    <v-col cols="2">
      <v-text-field
                    label="Data de validade"
                    v-model="value.expirationDate"
                    :rules="rules.expirationDate"
                    v-mask="'##/20##'"></v-text-field>
    </v-col>
    <v-col cols="2">
      <v-text-field
                    label="CVV"
                    v-model="value.cvv"
                    :rules="rules.cvv"
                    v-mask="'###'"></v-text-field>
    </v-col>
    <v-col cols="3">
      <v-text-field
                    label="Bandeira"
                    v-model="value.brand"
                    :rules="rules.required"
                    disabled></v-text-field>
    </v-col>
    <v-col cols="2">
      <v-img :src="assets.logoVisaMaster" height="100%" />
    </v-col>
  </v-row>
</template>
<script>
import assets from '../assets/assets';
export default {
  components: {
  },
  props: {
    user: Object,
    modelValue: Object,
  },
  emits: ["update:modelValue"],
  data() {
    return {
      assets: assets,
      requestingApi: null,
      brazilianBanks: [],
      rules: {
        required: [(v) => !!v || "Campo obrigatório"],
        cardNumber: [
          v => /^[0-9]{16}$/.test(v) || 'O cartão tem 16 números'
        ],
        cardBrand: [
          v => /^[245]/.test(v) || 'Bandeiras Suportadas : Visa ou MasterCard'
        ],
        cardHolder: [
          v => v && v.split(' ').length >= 2 && v.trim().length >= 3 || 'Nome deve ter pelo menos duas palavras'
        ],
        expirationDate: [
          v => /^((0[1-9])|(1[0-2]))\/((20)\d\d)$/.test(v) || 'Data inválida (xx/xxxx)'
        ],
        cvv: [
          v => /^\d{3}$/.test(v) || 'CVV precisa ter 3 números'
        ]
      },
    };
  },
  created() { },
  mounted() { },
  methods: {},
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    'value.cardNumber': {
      handler(newValue) {
        const vm = this;

        if (!/^[23456]/.test(newValue)) {
          vm.value.brand = '';
        } else if (newValue.startsWith(3)) {
          vm.value.brand = 'American Express';
        } else if (newValue.startsWith(4)) {
          vm.value.brand = 'Visa';
        } else if (newValue.startsWith(2) || newValue.startsWith(5)) {
          vm.value.brand = 'Master';
        } else if (newValue.startsWith(6)) {
          // vm.value.brand = 'Elo';
        }
        vm.value.name = vm.value.brand + newValue.substring(newValue.length - 4);
      },
      immediate: true
    },
  }
};
</script>
